import React from "react";
import { Email } from "../../icons/Footer/Email";

function FooterContact() {
  return (
    <div className="contact-container">
      <Email />
    </div>
  );
}

export default FooterContact;
